<div class="sidebar-container">
    <!-- Header bar -->
    <div class="sidebar-topbar">
        <span></span>
        <div class="d-flex align-items-center gap-2">
            <button nbButton status="success" size="small" (click)="save()">
                Sauvegarder
            </button>
            <button nbButton status="danger" size="small" (click)="closed.emit()" title="Fermer">
                <nb-icon icon="close-outline"></nb-icon> Fermer
            </button>
        </div>
    </div>

    <div *ngIf="loading" class="text-center p-4">
        <nb-spinner></nb-spinner>
    </div>

    <div *ngIf="!loading && campaign">
        <!-- Channel selector: affecte le ciblage global de la campagne -->
        <div class="d-flex align-items-center gap-2 mb-3 px-3 py-2 channel-selector-bar"
             [class.channel-active]="selectedChannel !== 'all'">
            <label class="mb-0 font-weight-bold">Canal d'achat :</label>
            <nb-select [(selected)]="selectedChannel" (selectedChange)="onChannelChange()" size="small">
                <nb-option value="all">Tout</nb-option>
                <nb-option value="web">Acheteur web</nb-option>
                <nb-option value="magasin">Acheteur magasin</nb-option>
            </nb-select>
            <span class="channel-badge ms-2" *ngIf="selectedChannel !== 'all'">
                <nb-icon icon="funnel-outline" pack="eva"></nb-icon>
                Ciblage limité — campagne envoyée uniquement à ces clients
            </span>
        </div>
        <div class="row">
            <!-- Left Column: Charts -->
            <div class="col-lg-7 col-md-7">
                <!-- Segment Matrix -->
                <app-segment-matrix
                    [achatMetadataMap]="achatMetadataMap"
                    [emailMetadataMap]="emailMetadataMap"
                    [valeurMetadataMap]="valeurMetadataMap"
                    [channel]="selectedChannel"
                    (addToSegment)="onMatrixAddToSegment($event)"></app-segment-matrix>

                <nb-card class="demo-card" *ngIf="isGlobalLoading || globalStats" [nbSpinner]="isGlobalLoading" nbSpinnerStatus="primary">
                    <nb-card-header>Données Démographiques (Sélection)</nb-card-header>
                    <nb-card-body>
                        <!-- Row 1: Buyer & Email pie charts -->
                        <div class="d-flex justify-content-center gap-3 mb-3">
                            <div style="flex: 0 1 45%;" *ngIf="pieChartDataSegmentAchat?.datasets?.[0]?.data?.length">
                                <label class="label font-weight-bold mb-1 d-block text-center">Type d'Acheteur</label>
                                <div style="height: 200px;">
                                    <canvas baseChart [data]="pieChartDataSegmentAchat"
                                        [options]="pieChartOptionsSegmentAchat" type="pie"></canvas>
                                </div>
                            </div>
                            <div style="flex: 0 1 45%;" *ngIf="pieChartDataSegmentEmail?.datasets?.[0]?.data?.length">
                                <label class="label font-weight-bold mb-1 d-block text-center">Engagement Email</label>
                                <div style="height: 200px;">
                                    <canvas baseChart [data]="pieChartDataSegmentEmail"
                                        [options]="pieChartOptionsSegmentEmail" type="pie"></canvas>
                                </div>
                            </div>
                        </div>

                        <!-- Row 2: Genre (Réalité + Segment) -->
                        <div class="d-flex justify-content-center gap-3 mb-3" *ngIf="genreRealiteChartData?.datasets?.[0]?.data?.length || genreSegmentChartData?.datasets?.[0]?.data?.length">
                            <div style="flex: 0 1 45%;" *ngIf="genreRealiteChartData?.datasets?.[0]?.data?.length">
                                <label class="label font-weight-bold mb-1 d-block text-center">Ventes des 30 derniers jours</label>
                                <div style="height: 120px;">
                                    <canvas baseChart [data]="genreRealiteChartData"
                                        [options]="genreSegmentChartOptions" [plugins]="chartPlugins" type="bar">
                                    </canvas>
                                </div>
                            </div>
                            <div style="flex: 0 1 45%;" *ngIf="genreSegmentChartData?.datasets?.[0]?.data?.length">
                                <label class="label font-weight-bold mb-1 d-block text-center">Segment</label>
                                <div style="height: 120px;">
                                    <canvas baseChart [data]="genreSegmentChartData"
                                        [options]="genreSegmentChartOptions" [plugins]="chartPlugins" type="bar"
                                        (chartClick)="onGenreChartClick($event)"></canvas>
                                </div>
                            </div>
                        </div>

                        <!-- Row 3: Pyramide des âges -->
                        <div class="d-flex justify-content-center mb-3">
                            <div style="width: 85%;" *ngIf="agePyramidData?.datasets?.length">
                                <label class="label font-weight-bold mb-1 d-block text-center">Pyramide des Âges</label>
                                <div style="height: 250px;">
                                    <canvas baseChart [data]="agePyramidData" [options]="agePyramidOptions"
                                        [plugins]="chartPlugins" type="bar"></canvas>
                                </div>
                            </div>
                        </div>
                    </nb-card-body>
                </nb-card>
            </div>

            <!-- Right Column: Settings -->
            <div class="col-lg-5 col-md-5">
    
                    <h6 class="mb-3">Nom du segment :</h6>
                    <div class="d-flex align-items-center gap-2">
                        <input type="text" nbInput fullWidth [(ngModel)]="campaign.name" (ngModelChange)="markDirty()" placeholder="Nom de la campagne">
                        <button nbButton size="small" status="basic" ghost
                                [nbSpinner]="isSuggestingName" nbSpinnerStatus="primary" nbSpinnerSize="tiny"
                                [disabled]="isSuggestingName"
                                nbTooltip="Suggérer un nom avec l'IA"
                                (click)="suggestName()">
                            <nb-icon icon="bulb-outline"></nb-icon>
                        </button>
                    </div>
                    <h6 class="mb-3 mt-4">Paramètres :</h6>

                <!-- AUDIENCE GROUPS LOOP -->
                <div *ngFor="let group of audienceGroups; let i = index" class="mb-3 position-relative">

                    <nb-card class="mb-0">
                        <nb-card-header class="d-flex justify-content-between align-items-center py-2">
                            <span class="text-hint font-weight-bold">Groupe {{ i + 1 }}</span>
                            <button nbButton ghost status="basic" size="tiny" (click)="removeGroup(i)"
                                *ngIf="audienceGroups.length > 1 || group.segments.length > 0"
                                title="Supprimer le groupe">
                                <nb-icon icon="trash-2-outline"></nb-icon>
                            </button>
                        </nb-card-header>
                        <nb-card-body>
                            <!-- Meta Selector -->
                            <div class="form-group mb-2">
                                <nb-select [formControl]="group.metaControl" fullWidth size="small"
                                    placeholder="Méta-catégorie">
                                    <nb-option *ngFor="let meta of metaCategories" [value]="meta.id">{{ meta.label
                                        }}</nb-option>
                                </nb-select>
                            </div>

                            <!-- Tags Input -->
                            <div class="form-group mb-0">
                                <nb-tag-list>
                                    <nb-tag *ngFor="let segment of group.segments; let j = index"
                                        [text]="getSegmentLabel(segment)" [removable]="true"
                                        (remove)="removeSegmentFromGroup(group, j)" status="basic" size="small"
                                        appearance="outline"></nb-tag>

                                    <input type="text" nbTagInput fullWidth [formControl]="group.searchControl"
                                        placeholder="Ajouter critère..." [nbAutocomplete]="autoGroup" />
                                </nb-tag-list>

                                <nb-autocomplete #autoGroup (selectedChange)="onCategorySelected(group, $event)">
                                    <nb-option *ngFor="let category of group.filteredCategories$ | async"
                                        [value]="category.label">
                                        {{ category.label }}
                                    </nb-option>
                                </nb-autocomplete>
                            </div>
                        </nb-card-body>
                    </nb-card>

                    <!-- AND Combinator -->
                    <div class="text-center my-2" *ngIf="i < audienceGroups.length - 1">
                        <span class="badge badge-pill badge-info font-weight-bold" style="font-size: 0.7rem;">ET</span>
                    </div>
                </div>

                <!-- ADD GROUP BUTTON -->
                <button nbButton fullWidth status="info" outline size="small" (click)="addGroup()"
                    class="mb-4 dashed-border">
                    <nb-icon icon="plus-outline"></nb-icon> Ajouter un groupe (ET)
                </button>

                <nb-card>
                    <nb-card-header>Filtres CRM</nb-card-header>
                    <nb-card-body>
                        <div class="mb-3 filter-row" *ngFor="let filter of filters; let i = index">
                            <div class="d-flex align-items-start gap-1">
                                <nb-select placeholder="Col" [(selected)]="filter.column" size="small"
                                    (selectedChange)="onFilterColumnChange(filter)" class="filter-select-col">
                                    <nb-option *ngFor="let col of availableColumns" [value]="col">{{
                                        columnDefs[col]?.label || col
                                        }}</nb-option>
                                </nb-select>
                                <!-- Operator select: hidden for 'between' (implicit) -->
                                <nb-select *ngIf="filter.operator !== 'between'" placeholder="Op"
                                    [(selected)]="filter.operator" size="small"
                                    (selectedChange)="updateFilter()" class="filter-select-op">
                                    <nb-option *ngFor="let op of getAvailableOperators(filter.column)"
                                        [value]="op">{{
                                        op }}</nb-option>
                                </nb-select>
                                <div class="filter-value">
                                    <!-- String Column: Tag List + Autocomplete -->
                                    <ng-container *ngIf="isStringColumn(filter.column); else dateOrNumberInput">
                                        <nb-tag-list>
                                            <nb-tag *ngFor="let val of filter.value; let j = index" [text]="val"
                                                [removable]="true" (remove)="onFilterTagRemove(filter, j)"
                                                [title]="getSegmentTooltip(filter.column, val)"
                                                status="basic" size="tiny"></nb-tag>

                                            <input #filterInput type="text" nbTagInput fullWidth
                                                [(ngModel)]="filter.searchValue"
                                                placeholder="Ajouter..." [nbAutocomplete]="autoFilter" />
                                        </nb-tag-list>

                                        <nb-autocomplete #autoFilter (selectedChange)="onFilterTagAdd(filter, $event, filterInput)">
                                            <nb-option *ngFor="let opt of getFilterOptionsObservable(filter) | async"
                                                [value]="opt"
                                                [title]="getSegmentTooltip(filter.column, opt)">
                                                {{ opt }}
                                            </nb-option>
                                        </nb-autocomplete>
                                    </ng-container>

                                    <!-- Date or Number Column -->
                                    <ng-template #dateOrNumberInput>
                                        <ng-container *ngIf="isDateColumn(filter.column); else numberInput">
                                            <!-- Date Column -->
                                            <div class="d-flex align-items-center gap-1"
                                                *ngIf="filter.operator === 'between'; else singleDateInput">
                                                <input nbInput type="date" [(ngModel)]="filter.valueMin"
                                                    (change)="onNumberRangeChange(filter)" class="flex-grow-1" fieldSize="small">
                                                <span style="color: #8f9bb3;">–</span>
                                                <input nbInput type="date" [(ngModel)]="filter.valueMax"
                                                    (change)="onNumberRangeChange(filter)" class="flex-grow-1" fieldSize="small">
                                            </div>
                                            <ng-template #singleDateInput>
                                                <input nbInput type="date" fullWidth
                                                    [(ngModel)]="filter.value" (change)="updateFilter()" fieldSize="small">
                                            </ng-template>
                                        </ng-container>

                                        <!-- Number Column -->
                                        <ng-template #numberInput>
                                            <div class="d-flex align-items-center gap-1"
                                                *ngIf="filter.operator === 'between'; else singleNumberInput">
                                                <input nbInput type="number" placeholder="Min" [(ngModel)]="filter.valueMin"
                                                    (change)="onNumberRangeChange(filter)" class="flex-grow-1" fieldSize="small">
                                                <span style="color: #8f9bb3;">–</span>
                                                <input nbInput type="number" placeholder="Max" [(ngModel)]="filter.valueMax"
                                                    (change)="onNumberRangeChange(filter)" class="flex-grow-1" fieldSize="small">
                                            </div>
                                            <ng-template #singleNumberInput>
                                                <input nbInput type="number" fullWidth placeholder="Valeur"
                                                    [(ngModel)]="filter.value" (change)="updateFilter()" fieldSize="small">
                                            </ng-template>
                                        </ng-template>
                                    </ng-template>
                                </div>
                                <button nbButton ghost status="danger" size="tiny" (click)="removeFilter(i)"
                                    class="filter-delete">
                                    <nb-icon icon="close-outline"></nb-icon>
                                </button>
                            </div>
                        </div>
                        <button nbButton size="tiny" status="basic" (click)="addFilter()">+ Filtre</button>
                        <div class="mt-3" *ngIf="dateColumn">
                            <nb-checkbox [(ngModel)]="excludeRecentBuyers" (checkedChange)="onExcludeRecentBuyersChange()">
                                Exclure les acheteurs des 14 derniers jours
                            </nb-checkbox>
                        </div>
                    </nb-card-body>
                </nb-card>

                <nb-card *ngIf="globalStats || isGlobalLoading" [nbSpinner]="isGlobalLoading" nbSpinnerStatus="primary">
                    <nb-card-header>{{ hasAudiences ? 'Optimisation Globale' : 'Volume Segment' }}</nb-card-header>
                    <nb-card-body>
                        <div class="mt-3">
                            <!-- Slider de pression: uniquement avec des catégories -->
                            <ng-container *ngIf="hasAudiences">
                                <label class="label mb-2">Pression Globale: {{ globalPercentage }}%</label>
                                <ngx-slider [(value)]="globalPercentage" [options]="globalSliderOptions"
                                    (userChange)="onGlobalSliderInput($event)"
                                    (userChangeEnd)="onGlobalSliderChangeEnd($event)">
                                </ngx-slider>
                            </ng-container>

                            <div class="stats-container mt-3">
                                <div class="row">
                                    <div class="col-6">
                                        <label class="label">Nombre emails ciblés</label>
                                        <div class="fw-bold" style="font-size: 1.2rem;">{{ globalStats?.numb_mail | number }}</div>
                                        <div class="text-info small mt-1" *ngIf="selectedChannel !== 'all'">
                                            <nb-icon icon="info-outline" pack="eva" style="font-size: 0.9rem;"></nb-icon>
                                            Restreint aux
                                            <strong>{{ selectedChannel === 'web' ? 'Acheteurs web' : 'Acheteurs magasin' }}</strong>
                                            (web pur + mixte, ou magasin + mixte)
                                        </div>
                                    </div>
                                    <div class="col-6" *ngIf="hasAudiences">
                                        <label class="label">
                                            <ng-container *ngIf="filters.length === 0">% Base Global (Total: {{
                                                globalScopeCount | number }})</ng-container>
                                            <ng-container *ngIf="filters.length > 0">% Base Filtrée (Total: {{
                                                globalScopeCount | number }})</ng-container>
                                        </label>
                                        <div>{{ globalStats?.pourcentBase }}%</div>
                                    </div>
                                    <!-- Potentiel & Lift: uniquement avec des catégories -->
                                    <ng-container *ngIf="hasAudiences">
                                        <div class="col-6 mt-2">
                                            <label class="label">Potentiel Cumulé</label>
                                            <div>{{ globalStats?.potential }}%</div>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="label">Lift Global</label>
                                            <div>{{ globalStats?.lift | number:'1.2-2' }}</div>
                                        </div>
                                    </ng-container>
                                </div>

                                <div class="mt-4" *ngIf="hasAudiences && globalCurveData">
                                    <label class="label">Courbe de Lift Globale</label>
                                    <div style="position: relative; height: 300px;">
                                        <canvas baseChart #globalChart="base-chart" [data]="globalCurveData"
                                            [options]="globalCurveOptions" [type]="'line'">
                                        </canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nb-card-body>
                </nb-card>

                <!-- Map: sous la courbe de gain -->
                <nb-card *ngIf="regionsMapData?.length">
                    <nb-card-header>Répartition Géographique</nb-card-header>
                    <nb-card-body>
                        <div id="sidebar-regions-map-container"
                            style="width: 100%; display: block; position: relative;">
                        </div>
                    </nb-card-body>
                </nb-card>

            </div>
        </div>
    </div>
</div>

<ng-template #dialogCurveError let-ref="dialogRef">
    <nb-card>
        <nb-card-body>{{ errorMessage }}</nb-card-body>
        <nb-card-footer>
            <div class="row">
                <div class="col text-center">
                    <button nbButton status="danger" (click)="ref.close()">Ok</button>
                </div>
            </div>
        </nb-card-footer>
    </nb-card>
</ng-template>

<ng-template #deleteConfirmDialog let-ref="dialogRef">
    <nb-card>
        <nb-card-header>Supprimer la campagne</nb-card-header>
        <nb-card-body>Êtes-vous sûr de vouloir supprimer cette campagne ?</nb-card-body>
        <nb-card-footer>
            <div class="row">
                <div class="col text-center">
                    <button nbButton status="danger" (click)="ref.close(true)">Oui, supprimer</button>
                </div>
                <div class="col text-center">
                    <button nbButton status="basic" (click)="ref.close(false)">Annuler</button>
                </div>
            </div>
        </nb-card-footer>
    </nb-card>
</ng-template>